import styles from "./FullModalContent.module.scss";

export default function FullModalContent ({children}) {
    return <div className={styles.FullModalContent}>{children}</div>
}